import React from 'react';
import { Sparkles } from 'lucide-react';

interface DataflowInsightEngineProps {
  insights: string[];
  compact?: boolean;
  className?: string;
}

/** Insight automático DataFlow — torna o sistema interpretativo. */
export const DataflowInsightEngine: React.FC<DataflowInsightEngineProps> = ({
  insights,
  compact = false,
  className = '',
}) => {
  if (insights.length === 0) return null;

  return (
    <section
      className={`rounded-lg border border-blue-200/80 bg-blue-50/40 dark:border-blue-900/40 dark:bg-blue-950/15 ${compact ? 'px-2 py-1.5' : 'px-3 py-2'} ${className}`}
    >
      <h4 className={`mb-1 flex items-center gap-1 font-bold uppercase tracking-wide text-[#2F6FED] ${compact ? 'text-[9px]' : 'text-[10px]'}`}>
        <Sparkles size={compact ? 11 : 13} />
        Insight DataFlow
      </h4>
      <ul className={`space-y-1 ${compact ? 'text-[10px]' : 'text-[11px]'} leading-snug text-slate-700 dark:text-slate-200`}>
        {insights.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
    </section>
  );
};

export default DataflowInsightEngine;
